export default {
    computed: {
        userClaims() {
            return this.$store.getters.getClaims
        },
    },

    async created() {
        await this.$store.dispatch('fetchClaims')
    },
  };